var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKleps(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 99,
    height: 87,
    viewBox: "0 0 99 87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_153",
    "data-name": "Group 153",
    transform: "translate(-144 -5910)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_8",
    "data-name": "Polygon 8",
    d: "M74.25,0,99,43.5,74.25,87H24.75L0,43.5,24.75,0Z",
    transform: "translate(144 5910)",
    fill: "#ffbe00"
  }), /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.941,7.68A3.621,3.621,0,0,1,9.541,10H3.651a3.631,3.631,0,0,1-3.4-2.32A3.6,3.6,0,0,1,1.2,3.67L5.241,0h2.71l4.04,3.67a3.6,3.6,0,0,1,.95,4.01ZM9.1,5.46a.681.681,0,0,0-.68-.68H4.781a.68.68,0,0,0,0,1.36h3.64A.687.687,0,0,0,9.1,5.46Z",
    transform: "translate(187.399 5954)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M11.994,6.33,7.954,10H5.244L1.2,6.33A3.63,3.63,0,0,1,3.644,0h5.9a3.635,3.635,0,0,1,2.45,6.33Zm-2.9-1.78a.681.681,0,0,0-.68-.68H4.774a.68.68,0,0,0,0,1.36h3.64A.687.687,0,0,0,9.094,4.55Z",
    transform: "translate(187.405 5944)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0H24V24H0Z",
    transform: "translate(206 5966) rotate(180)",
    fill: "none",
    opacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKleps);
export default __webpack_public_path__ + "static/media/kleps.17f16863ac7b95119cdeb02ea2e822c9.svg";
export { ForwardRef as ReactComponent };